<div class="flex items-center justify-between w-full col-span-2 gap-2">
  @if(!viewOddIcon()){
  <div></div>
  }
  <!--  -->
  @if(viewIconFavorite()){

  <img
    alt="logo"
    class="cursor-pointer max-sm:w-[15px]"
    [src]="getImgFavorite()"
    (click)="handlePropagation($event); toogleFavoriteMatch()"
  />
  } @else {
  <div></div>
  }
  <!--  -->
  @if(viewOddIcon()){
  <a [routerLink]="[getLinkOddIcon()]" (click)="handlePropagation($event)">
    <img
      alt="logo"
      class="cursor-pointer max-sm:w-[15px]"
      [src]="urlIcon + 'graph.svg'"
    />
  </a>

  }

  <img
    alt="logo"
    [src]="urlIcon + 'share-grey.svg'"
    class="max-sm:w-[16px] cursor-pointer"
    (click)="handlePropagation($event); toogleModalShared()"
    [nzPopoverVisible]="openModalShared()"
    nz-popover
    nzPopoverTrigger="click"
    [nzPopoverContent]="contentTemplate"
    nzPopoverPlacement="bottomRight"
  />
  <ng-template #contentTemplate>
    <app-share-modal [link]="getLinkShared()" (onClose)="toogleModalShared()" />
  </ng-template>
</div>
